/* Pławny — karta produktu: galeria, warianty, sticky bar, tabela rozmiarów */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.plInit === '1') return;
    root.dataset.plInit = '1';

    var hasOptions = root.dataset.hasOptions === 'true';
    var variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { variants = []; }

    var form = root.querySelector('form[action*="/cart/add"]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var priceNow = root.querySelector('[data-pdp-price-now]');
    var priceWas = root.querySelector('[data-pdp-price-was]');
    var stickyBar = root.querySelector('[data-pdp-sticky]');
    var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
    var stickyBtn = root.querySelector('[data-pdp-sticky-add]');
    var dialog = root.querySelector('[data-pdp-size-dialog]');
    var sizeOpen = root.querySelector('[data-pdp-size-open]');
    var sizes = root.querySelector('.pl-pdp__sizes');

    var LABEL_ADD = root.dataset.labelAdd || '';
    var LABEL_CHOOSE = root.dataset.labelChoose || '';

    /* ---------- galeria ---------- */
    var frames = root.querySelectorAll('[data-pdp-frame]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.dataset.pdpThumb;
        frames.forEach(function (f) { f.classList.toggle('is-active', f.dataset.pdpFrame === idx); });
        thumbs.forEach(function (t) {
          var on = t === thumb;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      });
    });

    /* ---------- tabela rozmiarów ---------- */
    if (sizeOpen && dialog) {
      sizeOpen.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    }

    /* ---------- warianty ---------- */
    function selectedInput() {
      return root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"][type="hidden"]');
    }

    function sync() {
      var input = selectedInput();
      var chosen = input && input.type === 'radio' ? input : (hasOptions ? null : input);

      if (chosen && chosen.dataset && chosen.dataset.price) {
        if (priceNow) priceNow.textContent = chosen.dataset.price;
        if (stickyPrice) stickyPrice.textContent = chosen.dataset.price;
        if (priceWas) {
          var cmp = chosen.dataset.compare;
          priceWas.style.display = (cmp && cmp !== chosen.dataset.price) ? '' : 'none';
          if (cmp) priceWas.textContent = cmp;
        }
      }

      var ready = !hasOptions || !!chosen;
      if (addBtn && !addBtn.hasAttribute('data-sold-out')) {
        addBtn.disabled = !ready;
        if (LABEL_ADD && LABEL_CHOOSE) addBtn.textContent = ready ? LABEL_ADD : LABEL_CHOOSE;
      }
      if (stickyBtn && LABEL_ADD && LABEL_CHOOSE) {
        stickyBtn.textContent = ready ? LABEL_ADD : LABEL_CHOOSE;
      }
    }

    root.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', sync);
    });

    /* ---------- sticky mobile ---------- */
    if (stickyBar && addBtn) {
      stickyBar.hidden = false;
      var observed = root.querySelector('.pl-pdp__buy');
      if ('IntersectionObserver' in window && observed) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { rootMargin: '-120px 0px 0px 0px', threshold: 0 });
        io.observe(observed);
      }
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (hasOptions && !root.querySelector('input[name="id"]:checked')) {
            if (sizes) {
              sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
              sizes.classList.add('is-flash');
              setTimeout(function () { sizes.classList.remove('is-flash'); }, 900);
            }
            return;
          }
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-pl-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
